/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const EventTopic = core.serialization.enum_([
    "agent:created",
    "agent:updated",
    "agent:deleted",
    "space:created",
    "space:updated",
    "space:deleted",
    "space:archived",
    "space:unarchived",
    "space:expired",
    "space:guestAdded",
    "space:guestRemoved",
    "document:created",
    "document:updated",
    "document:deleted",
    "workbook:created",
    "workbook:updated",
    "workbook:deleted",
    "workbook:expired",
    "workbook:thawed",
    "flag:created",
    "flag:updated",
    "flag:deleted",
    "sheet:created",
    "sheet:updated",
    "sheet:deleted",
    "sheet:counts-updated",
    "sheet:calculation-updated",
    "snapshot:created",
    "records:created",
    "records:updated",
    "records:deleted",
    "file:created",
    "file:updated",
    "file:deleted",
    "file:expired",
    "job:created",
    "job:updated",
    "job:deleted",
    "job:completed",
    "job:ready",
    "job:scheduled",
    "job:outcome-acknowledged",
    "job:parts-completed",
    "job:failed",
    "program:created",
    "program:updated",
    "program:recomputing",
    "program:recomputed",
    "commit:created",
    "commit:updated",
    "commit:completed",
    "layer:created",
    "secret:created",
    "secret:updated",
    "secret:deleted",
    "cron:5-minutes",
    "cron:hourly",
    "cron:daily",
    "cron:weekly",
    "environment:created",
    "environment:updated",
    "environment:deleted",
    "environment:autobuild-created",
    "action:created",
    "action:updated",
    "action:deleted",
    "data-clip:created",
    "data-clip:updated",
    "data-clip:deleted",
    "data-clip:collaborator-updated",
    "data-clip:resolutions-created",
    "data-clip:resolutions-updated",
    "data-clip:resolutions-refreshed",
    "canvas:created",
    "canvas:updated",
    "canvas:deleted",
    "canvas-area:created",
    "canvas-area:updated",
    "canvas-area:deleted",
    "thread:created",
    "thread:updated",
    "thread:deleted",
]);
